module.exports = __webpack_public_path__ + "img/img_xxxy_brand.087f0646.png";